module.exports = __webpack_public_path__ + "static/img/iconEmployee.bcb5f54.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/iconEmployee.png
// module id = XyqG
// module chunks = 1